/**
 *
 */
export const arrowDown = {
    paths: [
        {
            d: 'M13.03 8.22a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.47 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l2.97 2.97V3.75a.75.75 0 0 1 1.5 0v7.44l2.97-2.97a.75.75 0 0 1 1.06 0Z',
        },
    ],
    viewBox: '0 0 16 16',
};
//# sourceMappingURL=arrow-down.js.map